import { render, staticRenderFns } from "./SalesOrderFilter.vue?vue&type=template&id=2af85efc&"
import script from "./SalesOrderFilter.vue?vue&type=script&lang=ts&"
export * from "./SalesOrderFilter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports